import { Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';
import { VersionsService } from '@core/services/versions/versions.service';
import { RecorderService } from '@core/services/recorder/recorder.service';



import * as Objects from '@core/objects';
import { VersionFeedback } from '@core/models/version-feedback';
import { VersionShare } from '@core/models/version-share.model';
import { VersionFeedbackMessage } from '@core/models/version-feedback-message';
// core recorder state 
import * as fromState from '@core/store/state/recorder/recorder.state';

@Component({
    selector: 'plugin-share-feedback-core-version-messages',
    templateUrl: './version-messages.component.html',
    styleUrls: ['./version-messages.component.scss']
})
export class PluginShareFeedbackCoreVersionMessagesComponent implements OnInit, OnChanges, OnDestroy {
    protected readonly PLUGIN_SHARE_FEEDBACK_CONTEXT = 'plugin-share-feedback';

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_FOUND = 3;

    @Input() version: Objects.Version = null;
    @Input() feedbacks: Array<VersionFeedback> = null;
    @Input() versionShares: Array<VersionShare> = null;
    @Input() user: Objects.User = null;
    @Input() addMessage: boolean = false;
    @Input() notesActionText: string;
    @Input() notesActionStyle: string;
    @Input() canCreateNotes: boolean = true;
    @Input() canDelete: boolean = true; // message
    @Input() prefixUrl: string = '';
    @Input() prefixNotesUrl: string = '';

    public messagesList: Array<VersionFeedbackMessage> = null;
    public messages: Array<VersionFeedbackMessage> = null;
    public feedbackMessages: Array<VersionFeedbackMessage> = null;
    public status: number = this.STATUS_LOADING;
    // for videomessage feature
    public context: string = this.PLUGIN_SHARE_FEEDBACK_CONTEXT;

    // legacy variables
    public messageAddUrl: string;

    protected recorderSubscriptor: Subscription;

    constructor(private versionsSrv: VersionsService, private urlSrv: UrlService,
        private recorderSrv: RecorderService ) { }

    ngOnInit() {
        // console.log(" CAN create notes ",this.canCreateNotes);
        
        // here we check the recorder status to reload messages
        this.recorderSubscriptor = this.recorderSrv.getStatus().subscribe((status: fromState.RecorderStatus ) => {
            // console.debug(" STATUS RECORDER FINISHEd is (8) ==> ",status);
            if(status == fromState.RecorderStatus.FINISHED_SUCCESS){
                console.debug(" loadMessages when STATUS RECORDER FINISHEd is (8) ==> ",status);
                this.loadMessages();
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.version && this.version != null)
            this.init();
        if(changes.feedbacks && this.feedbacks != null){
            this.initApprovals();
        }
        if(changes.versionShares && this.versionShares != null){
            this.initApprovals();
        }
    }

    ngOnDestroy(): void {
        this.messagesList = null;
        this.recorderSubscriptor.unsubscribe();
    }

    protected init() {
        this.messageAddUrl = this.urlSrv.build(this.prefixUrl+"/versions/"+this.version.id+"/messages");
        this.status = this.STATUS_LOADING;
        // this.selectedFile = null;
        this.loadMessages();

    }

    protected initApprovals(){
        let approvalList:VersionFeedbackMessage[] = (this.feedbacks?.length > 0) ? this.feedbacks.filter((f:VersionFeedback) => f.approval != null && f.approval.status_code != 0)
            .map((f:VersionFeedback) => {
                return {message: null, feedback: f, date:f.approval.date};
            }) : [];
        
        this.feedbackMessages = approvalList;
        this.prepareMessages();
    }

    protected loadMessages(){
        // here we only load messages
        this.versionsSrv.getMessages$(this.version, this.prefixUrl).subscribe((messages: Array<Objects.Message>) => {
            if(messages != null){
                this.messages = messages.map((m:Objects.Message) => {
                    return {message: m,feedback:null, date:m.date};
                });
                this.prepareMessages();
            }
        });
    }

    protected prepareMessages(){
        if(this.messages != null && this.feedbackMessages != null ){
            let msgList: VersionFeedbackMessage[]  =  this.messages.map((msg: VersionFeedbackMessage) => {
                let feedbacks = (this.feedbacks?.length > 0) ? this.feedbacks.filter((f:VersionFeedback) => f.user.id == msg.message.user.id) : [];
                if(feedbacks.length > 0){
                    return {message: msg.message,feedback: feedbacks[0], date:msg.message.date };
                } else {
                    return {message: msg.message, date:msg.message.date };
                }
            });
            // this is for the approval BUILT messages to display the approve/rejection messages, not real messages
            let approvalList:VersionFeedbackMessage[] = (this.feedbacks?.length > 0) ? this.feedbacks.filter((f:VersionFeedback) => f.approval != null && f.approval.status_code != 0)
                                            .map((f:VersionFeedback) => {
                                                return {message: null, feedback: f, date:f.approval.date};
                                            }) : [];

            this.messagesList = [...msgList,...approvalList];
            this.status = this.STATUS_DONE
        }
        // dec-2023 case when we have new VersionShares
        if(this.messages != null && this.versionShares != null ){
            let msgList: VersionFeedbackMessage[]  =  this.messages.map((msg: VersionFeedbackMessage) => {
                let shares = (this.versionShares.length > 0) ? this.versionShares.filter((vs:VersionShare) => vs.entry.user.id == msg.message.user.id) : [];
                if(shares && shares.length > 0){
                    return {message: msg.message, version_shares: shares, date:msg.message.date };
                } else {
                    return {message: msg.message, date:msg.message.date };
                }
            });
            // this is for the approval BUILT messages to display the approve/rejection messages, not real messages
            let approvalList:VersionFeedbackMessage[] = (this.feedbacks?.length > 0) ? this.feedbacks.filter((f:VersionFeedback) => f.approval != null && f.approval.status_code != 0)
                                            .map((f:VersionFeedback) => {
                                                return {message: null, feedback: f, date:f.approval.date};
                                            }) : [];

            this.messagesList = [...msgList,...approvalList];
            this.status = this.STATUS_DONE
        }
    }

    public saveMessage(message: Objects.Message){
        this.loadMessages();
    }

    public messageDeleted(message: Objects.Message){
        // TODO with messagesSrv
        console.debug("message delete clicked ", message);
        this.loadMessages();
    }


}
